import {
  PERITADOR_ACT_GET_REQUEST_BEGIN,
  PERITADOR_ACT_GET_REQUEST_SUCCESS,
  PERITADOR_ACT_GET_REQUEST_FAILURE,
  PERITADOR_ACT_GET_REQUEST_DISMISS_ERROR,
} from './constants';
import { getRequest } from '../../../common/BFF/BFF_peritador/getRequest'
 
export function actGetRequest(requestsId) {
  return (dispatch) => { 
    dispatch({
      type: PERITADOR_ACT_GET_REQUEST_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      getRequest(requestsId).then(request => {
        if (!!request) {
          dispatch({
            type: PERITADOR_ACT_GET_REQUEST_SUCCESS,
            data: request,
          });
          resolve(request);
        } else {
          dispatch({
            type: PERITADOR_ACT_GET_REQUEST_FAILURE,
            data: { error: null },
          });
          reject(null);
        }
      })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActGetRequestError() {
  return {
    type: PERITADOR_ACT_GET_REQUEST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_GET_REQUEST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actGetRequestPending: true,
        actGetRequestError: null,
      };

    case PERITADOR_ACT_GET_REQUEST_SUCCESS:
      // The request is success
      return {
        ...state,
        request: action.data,
        actGetRequestPending: false,
        actGetRequestError: null,
      };

    case PERITADOR_ACT_GET_REQUEST_FAILURE:
      // The request is failed
      return {
        ...state,
        actGetRequestPending: false,
        actGetRequestError: action.data.error,
      };

    case PERITADOR_ACT_GET_REQUEST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actGetRequestError: null,
      };

    default:
      return state;
  }
}



